import { useCharacterLikeMutation } from '~/features/user';
import { Chat01RoomType } from '~/types';

const useCharacterLikeActions = ({
  query,
  type = 'user',
}: {
  query?: string;
  type?: Chat01RoomType;
} = {}) => {
  const { mutate: handleCharacterLike } = useCharacterLikeMutation();

  /**
   * 캐릭터 좋아요 클릭 핸들러
   * @param id 캐릭터 id
   * @param isLiked 기존 좋아요 여부
   */
  const handleLikeClick = (id: string, isLiked: boolean) =>
    handleCharacterLike({
      character_id: id,
      operation: isLiked ? 'unlike' : 'like',
      query,
      type,
    });

  return {
    handleLikeClick,
  };
};

export default useCharacterLikeActions;
